<script lang="ts">
  import { _ } from "svelte-i18n";
  import { fade } from "svelte/transition";
</script>

<div in:fade class="center">{$_('page_not_found_message')}</div>
